import { AppLayout, SpaceBetween } from '@amzn/awsui-components-core';
import React, { useCallback, useState } from 'react';
import { OESideNavigation } from 'src/components/fintech-ops/fintech-ops-dashboard/OESideNavigation';

import { buildBreadcrumbChain } from 'src/utilities/RouteConfig';
import { TicketsParsedDataItem } from '../tickets/TicketsInterfaces';
import { UserMetricsParsedData } from '../user-metrics/UserMetricsInterfaces';
import { createEmptyBusinessReportingAggregatedData, createEmptyChartData } from './BusinessReportingConstants';
import { BusinessReportingData, BusinessReportingFilters, BusinessReportingSelectionFilters } from './BusinessReportingSelectionFilters';
import { ProcessedBusinessReportingData } from './BusinessReportingTicketDataProcessing';
import { BusinessReportingTicketSection } from './BusinessReportingTicketSection';
import { ProcessedBusinessReportingUserData } from './BusinessReportingUserDataProcessing';
import { BusinessReportingUserSection } from './BusinessReportingUserSection';

export const BusinessReportingPage: React.FC = () => {
  const [filters, setFilters] = useState<BusinessReportingFilters>({ applications: [], rollupPeriod: 'Quarterly', period: [] });
  const [ticketData, setTicketData] = useState<{ filtered: TicketsParsedDataItem[]; processed: ProcessedBusinessReportingData }>({
    filtered: [],
    processed: {
      aggregatedData: createEmptyBusinessReportingAggregatedData(),
      ...createEmptyChartData(),
      processedFilters: '{}'
    }
  });
  const [userData, setUserData] = useState<{ filtered: UserMetricsParsedData[]; processed: ProcessedBusinessReportingUserData }>({
    filtered: [],
    processed: {
      aggregatedData: [],
      viewershipByAppData: [],
      viewershipByAppXDomain: [],
      viewershipByAppYDomain: [],
      top5AppsViewership: [],
      top5AppsViewershipXDomain: [],
      top5AppsViewershipYDomain: [],
      uniqueUsersByApplication: [],
      uniqueUsersByApplicationXDomain: [],
      uniqueUsersByApplicationYDomain: [],
      processedFilters: '{}'
    }
  });
  const [originalFilterOptions, setOriginalFilterOptions] = useState<string>('');
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const handleFiltersChange = useCallback((data: BusinessReportingData) => {
    setFilters(data.filters);
    setTicketData({ filtered: data.filteredTicketData, processed: data.processedTicketData });
    setUserData({ filtered: data.filteredUserMetricsData, processed: data.processedUserData });
    setOriginalFilterOptions(data.originalFilterOptions);
    setIsLoading(data.isLoading);
  }, []);

  return (
    <AppLayout
      contentType="cards"
      navigation={<OESideNavigation />}
      toolsHide={true}
      maxContentWidth={Number.MAX_VALUE}
      content={
        <SpaceBetween size="xl">
          <BusinessReportingSelectionFilters onFiltersChange={handleFiltersChange} />
          <SpaceBetween size="l">
            <BusinessReportingTicketSection
              processedTicketData={ticketData.processed}
              processedUserData={userData.processed}
              businessFilters={filters}
              originalFilterOptions={originalFilterOptions}
              isLoading={isLoading}
            />
            <BusinessReportingUserSection
              processedUserData={userData.processed}
              filters={filters}
              isLoading={isLoading}
              originalFilterOptions={originalFilterOptions}
            />
          </SpaceBetween>
        </SpaceBetween>
      }
    />
  );
};
